module.exports = __webpack_public_path__ + "static/img/诗仙会客厅1.6cc25082.png";